import React from 'react';
import './ContactLayout.css'; // Updated CSS file name
import instaIcon from '../../assets/images/socialIcons/instagram.png'
import LinkIcon from '../../assets/images/socialIcons/linkedin.png'
import facebookIcon from '../../assets/images/socialIcons/facebook.png'
import wpIcon from '../../assets/images/socialIcons/wpLogo.png'

const SocialMediaLayout = () => {
  // Social media URLs
  const socialLinks = {
    instagram: "https://www.instagram.com/mento.in/",
    whatsapp: "https://wa.me/+919057250085",
    linkedin: "https://www.linkedin.com/company/connectmento/",
    facebook: "https://www.facebook.com/profile.php?id=61566015786803&rdid=oI04F87TMbtHmXL5&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1EjHzVoh32%2F#"
  };

  // Function to handle click and redirect
  const handleRedirect = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="contact-wrapper">
      <h1 className="contact-heading">Contact Us</h1>
      <div className="platform-grid">
        <div className="platform-card" onClick={() => handleRedirect(socialLinks.instagram)}>
          <div 
            className="icon-container" 
            aria-label="Visit Instagram"
          >
            <img 
              src={instaIcon} 
              alt="Instagram" 
              className="platform-icon"
            />
          </div>
          <span className="platform-label">@mento.in</span>
        </div>
        
        <div className="platform-card" onClick={() => handleRedirect(socialLinks.whatsapp)}>
          <div 
            className="icon-container" 
            aria-label="Open WhatsApp"
          >
            <img 
              src={wpIcon} 
              alt="WhatsApp" 
              className="platform-icon"
            />
          </div>
          <span className="platform-label">+91 9057250085</span>
        </div>
        
        <div className="platform-card" onClick={() => handleRedirect(socialLinks.linkedin)}>
          <div 
            className="icon-container" 
            aria-label="Visit LinkedIn"
          >
            <img 
              src={LinkIcon} 
              alt="LinkedIn" 
              className="platform-icon"
            />
          </div>
          <span className="platform-label">connectmento</span>
        </div>
        
        <div className="platform-card" onClick={() => handleRedirect(socialLinks.facebook)}>
          <div 
            className="icon-container" 
            aria-label="Visit Facebook"
          >
            <img 
              src={facebookIcon} 
              alt="Facebook" 
              className="platform-icon"
            />
          </div>
          <span className="platform-label">Mento</span>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaLayout;